import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { login } from "./ApiService";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { convertPhoneNumber } from "../../utils/phone-number";
export default function LoginButton({
  emailPhoneValue,
  passwordValue,
  errorEmailPhone,
  errorPassword,
  setError,
}) {
  const navigate = useNavigate();

  const [cookies, setCookie] = useCookies(["access_token"]);

  const handleLogin = async () => {
    let expires = new Date();
    expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);
    if (errorEmailPhone === errorPassword) {
      try {
        //regex for phone
        const phoneRegex = /^[0-9]{10}$/;
        if (emailPhoneValue.match(phoneRegex)) {
          const result = await login(
            convertPhoneNumber(emailPhoneValue),
            passwordValue
          );
          console.log("Login successful:", result);
          setCookie("access_token", result.token, {
            path: "/",
            expires: expires,
            maxAge: 7 * 24 * 60 * 60,
            secure: true,
            sameSite: "strict",
          });
          navigate("/home");
        } else {
          const result = await login(emailPhoneValue, passwordValue);
          console.log("Login successful:", result);
          setCookie("access_token", result.token, {
            path: "/",
            expires: expires,
            maxAge: 7 * 24 * 60 * 60,
            secure: true,
            sameSite: "strict",
          });
          navigate("/home");
        }

        // set access token to cookies

        // Redirect to home page
      } catch (err) {
        console.error("Login failed:", err);
        setError(err.message || "Login failed");
      }
    }
  };
  const { t } = useTranslation();
  return <PrimaryButton text={t("login")} onClick={handleLogin} />;
}
